"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _dashboard = require("@/api/dashboard");
var _auth = require("@/utils/auth");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _internal = require("@/components/uploadPicture/internal.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入本地上传工具函数
var _default = exports.default = {
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      showDialog: false,
      step: 0,
      tableData: [{
        comboName: '医卡通398套餐',
        services: ['报告解读', '运动方案', '门诊预约', '陪诊服务'],
        badge: 1,
        price: '398元',
        originalPrice: '498元',
        online: true,
        stock: 1,
        times: 1,
        gift: 1,
        remark: '',
        operator: '',
        createTime: ''
      }, {
        comboName: '医卡通598套餐',
        services: ['报告解读', '运动方案', '门诊预约', '陪诊服务'],
        badge: null,
        price: '598元',
        originalPrice: '698元',
        online: true,
        stock: 1,
        times: 2,
        gift: 2,
        remark: '',
        operator: '',
        createTime: ''
      }],
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      formStoreSelect: [],
      form: {
        online: true,
        imageList: [],
        tagList: [],
        auths: [],
        customerIdList: [],
        description: ''
      },
      urlImage: '',
      inputVisible: false,
      inputValue: '',
      serviceTable: [],
      authList: [],
      typeEdit: true,
      ids: null,
      rowImg: {
        serviceIcon: ''
      }
    };
  },
  mounted: function mounted() {
    this.handleApiResult();
    this.handleAutoListApi();
    this.handleCustomersListApi();
    this.handleAutoType();
  },
  methods: {
    handleApiResult: function () {
      var _handleApiResult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _dashboard.serviceProductList)(this.listPram);
            case 1:
              res = _context.v;
              this.tableData = res.list;
              this.listPram.page = res.page;
              this.listPram.total = res.total;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleApiResult() {
        return _handleApiResult.apply(this, arguments);
      }
      return handleApiResult;
    }(),
    handleAutoListApi: function () {
      var _handleAutoListApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _dashboard.companyAutoListByTypetApi)({
                productType: 1
              });
            case 1:
              res = _context2.v;
              this.formStoreSelect = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleAutoListApi() {
        return _handleAutoListApi.apply(this, arguments);
      }
      return handleAutoListApi;
    }(),
    handleCustomersListApi: function () {
      var _handleCustomersListApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _dashboard.customersListApi)();
            case 1:
              res = _context3.v;
              this.authList = res;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleCustomersListApi() {
        return _handleCustomersListApi.apply(this, arguments);
      }
      return handleCustomersListApi;
    }(),
    handleAutoType: function () {
      var _handleAutoType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return (0, _dashboard.productConfigList)({
                productType: 1
              });
            case 1:
              res = _context4.v;
              this.serviceTable = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleAutoType() {
        return _handleAutoType.apply(this, arguments);
      }
      return handleAutoType;
    }(),
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      console.log(value, 'value');
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, _params, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              if (!this.typeEdit) {
                _context5.n = 2;
                break;
              }
              params = _objectSpread(_objectSpread({}, this.form), {}, {
                configList: this.serviceTable
              });
              _context5.n = 1;
              return (0, _dashboard.productConfigSave)(params);
            case 1:
              this.$message.success('提交成功');
              this.showDialog = false;
              this.step = 0;
              _context5.n = 4;
              break;
            case 2:
              if (this.typeEdit) {
                _context5.n = 4;
                break;
              }
              _params = _objectSpread(_objectSpread({}, this.form), {}, {
                configList: this.serviceTable,
                id: this.ids
              });
              _context5.n = 3;
              return (0, _dashboard.productUpdate)(_params);
            case 3:
              this.$message.success('更改成功');
              this.showDialog = false;
              this.step = 0;
            case 4:
              this.handleApiResult();
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t2 = _context5.v;
              this.$message.error(_t2);
            case 6:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 5]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    addTag: function addTag() {
      if (this.inputValue) {
        this.form.tagList.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    removeTag: function removeTag(tag) {
      this.form.tagList = this.form.tagList.filter(function (t) {
        return t !== tag;
      });
    },
    handleDelete: function handleDelete(index) {
      this.form.imageList.splice(index, 1);
    },
    //上传图片
    handleUploadFormNew: function () {
      var _handleUploadFormNew = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this = this; // 使用Windows本地文件上传方式
              window.$loading = this.$loading;
              (0, _internal.uploadLocalImage)({
                multiple: true,
                maxCount: 5,
                model: 'product',
                pid: 1,
                onSuccess: function onSuccess(url) {
                  _this.form.imageList.push(url);
                  _this.$message.success('图片上传成功');
                },
                onError: function onError(error) {
                  _this.$message.error(error.message || '上传失败');
                }
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleUploadFormNew() {
        return _handleUploadFormNew.apply(this, arguments);
      }
      return handleUploadFormNew;
    }(),
    //上传图片
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this = this; // 使用Windows本地文件上传方式
              window.$loading = this.$loading;
              (0, _internal.uploadLocalImage)({
                multiple: false,
                model: 'product',
                pid: 1,
                onSuccess: function onSuccess(url) {
                  _this.rowImg.serviceIcon = url;
                  _this.urlImage = url;
                  _this.$message.success('图片上传成功');
                },
                onError: function onError(error) {
                  _this.$message.error(error.message || '上传失败');
                }
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function handleUploadForm() {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    handleUpImg: function handleUpImg(row) {
      this.rowImg = row;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleApiOffsetList(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleApiOffsetList(this.listPram);
    },
    onlineChange: function () {
      var _onlineChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(val) {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return (0, _dashboard.productStatus)({
                id: val.id,
                status: val.status
              });
            case 1:
              res = _context8.v;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }));
      function onlineChange(_x) {
        return _onlineChange.apply(this, arguments);
      }
      return onlineChange;
    }(),
    handleShowPopup: function handleShowPopup() {
      this.step = 0;
      this.form = {
        online: true,
        imageList: [],
        tagList: [],
        auths: [],
        customerIdList: [],
        description: ''
      };
      if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.setContent) {
        this.$refs.tinymceEditor.setContent('');
      }
      this.handleAutoType();
      this.typeEdit = true;
      this.showDialog = true;
    },
    handleEdit: function () {
      var _handleEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(row) {
        var res, _t3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.step = 0;
              _context9.p = 1;
              this.handleCustomersListApi();
              _context9.n = 2;
              return (0, _dashboard.serviceInfo)({
                id: row.id
              });
            case 2:
              res = _context9.v;
              this.typeEdit = false;
              this.form = _objectSpread({}, res);
              if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.setContent) {
                this.$refs.tinymceEditor.setContent(res.description);
              }
              this.ids = row.id;
              this.serviceTable = res.configList;
              this.showDialog = true;
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t3 = _context9.v;
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3]]);
      }));
      function handleEdit(_x2) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }()
  }
};